import { render } from "./imageUpload.vue?vue&type=template&id=642b95f4&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"

import "./imageUpload.vue?vue&type=style&index=0&id=642b95f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-642b95f4"

export default script